<app-field-container [field]="this">
  <input type="email" class="form-control"
         [formControl]="control"
         [placeholder]="placeholder() ?? ''"
         [maxlength]="maxLength()"
         [readonly]="readonly()"/>
  <app-chars-left
    [maxLength]="maxLength()"
    [charsLeft]="charsLeft()"
    [charsLeftThreshold]="charsLeftThreshold()">
  </app-chars-left>
</app-field-container>
